/* @flow @format */

import { type ActionType, createAction } from '../utils';
import type { FailurePayload } from '../types';
import type { FetchAgreementInput } from '../../graphql/api';

export type Term = {
  +privacyPolicySigned: boolean,
  +termsOfUseSigned: boolean,
  +timestamp: string,
};

// Actions

export const FETCH_AGREEMENT_BEGIN: 'proc/auth/FETCH_AGREEMENT_BEGIN' = 'proc/auth/FETCH_AGREEMENT_BEGIN';
export const FETCH_AGREEMENT_SUCCESS: 'proc/auth/FETCH_AGREEMENT_SUCCESS' = 'proc/auth/FETCH_AGREEMENT_SUCCESS';
export const FETCH_AGREEMENT_FAILURE: 'proc/auth/FETCH_AGREEMENT_FAILURE' = 'proc/auth/FETCH_AGREEMENT_FAILURE';

export const fetchAgreementBegin = createAction<typeof FETCH_AGREEMENT_BEGIN, FetchAgreementInput>(
  FETCH_AGREEMENT_BEGIN
);
export const fetchAgreementSuccess = createAction<typeof FETCH_AGREEMENT_SUCCESS, Term>(FETCH_AGREEMENT_SUCCESS);
export const fetchAgreementFailure = createAction<typeof FETCH_AGREEMENT_FAILURE, FailurePayload<FetchAgreementInput>>(
  FETCH_AGREEMENT_FAILURE
);

export type TermActionType =
  | ActionType<typeof fetchAgreementBegin>
  | ActionType<typeof fetchAgreementSuccess>
  | ActionType<typeof fetchAgreementFailure>;

const initialState = {
  privacyPolicySigned: false,
  termsOfUseSigned: false,
  timestamp: '',
};

export default function reducer(state: Term = initialState, action: TermActionType) {
  switch (action.type) {
    case FETCH_AGREEMENT_BEGIN:
      return initialState;
    case FETCH_AGREEMENT_SUCCESS:
      return action.payload;
    case FETCH_AGREEMENT_FAILURE:
      return state;
    default:
      /*::(action: empty);*/
      return state;
  }
}
